module.exports = __webpack_public_path__ + "img/photo-0012.6eb19359.jpg";